"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/teamSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type TeamSection346sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/team/team-img-1.png" | "/Templates/Doccure/img/team/team-img-2.png" | "/Templates/Doccure/img/team/team-img-3.png" | "/Templates/Doccure/img/team/team-img-4.png" */
    src: string;
    /** Detected variants: "Dr. James Anderson" | "Dr. Sarah Mitchell" | "Dr. Jordan Michael" | "Dr. Emily Chen" */
    link0Text: ReactNode;
    /** Detected variants: "Audiology & Hearing Disorders" | "Rhinology & Sinus Surgery" | "Eardrum Surgeon" */
    p0Text: ReactNode;
    /** Detected variants: "col-xl-3 col-lg-4 col-sm-6" */
    className?: string;
    /** Detected variants: "team-item-five" */
    div0ClassName?: string;
    /** Detected variants: "team-overley" */
    div0ClassName2?: string;
    /** Detected variants: "team-img-1" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "team-img-1" */
    imageWithBasePath1Alt?: string;
    /** Detected variants: "img-fluid img-2" */
    imageWithBasePath1ClassName?: string;
    /** Detected variants: "/Templates/Doccure/img/bg/team-bg-1.png" */
    imageWithBasePath1Src?: string;
    /** Detected variants: "team-details" */
    div1ClassName?: string;
    /** Detected variants: "custom-title author-name" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "author-dest" */
    p0ClassName?: string;
};
export type HomeFiveTeamSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection346sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "OUR EXPERT TEAM" */
    sectionDiv0Div0Div0DivText?: ReactNode;
    /** Default: "icon" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/title-icon1.svg" */
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Highly Qualified ENT Specialists" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    sectionDiv0Div1ClassName?: string;
    teamSection346s: TeamSection346sItem[];
    teamSection346sItemWrapper?: (item: TeamSection346sItem, content: ReactNode) => ReactNode;
    teamSection346sRenderer?: (defaultNode: ReactNode) => ReactNode;
    teamSection346sLinkVisible?: boolean;
    teamSection346sLinkRenderer?: (item: TeamSection346sItem, defaultNode: ReactNode) => ReactNode;
    teamSection346sImageVisible?: boolean;
    teamSection346sImageRenderer?: (item: TeamSection346sItem, defaultNode: ReactNode) => ReactNode;
    teamSection346sH3Visible?: boolean;
    teamSection346sH3Renderer?: (item: TeamSection346sItem, defaultNode: ReactNode) => ReactNode;
    teamSection346sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: TeamSection346sItem) => Partial<ComponentProps<typeof SmartLink>>);
    teamSection346sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: TeamSection346sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    teamSection346sH3Props?: Partial<ComponentProps<"h3">> | ((item: TeamSection346sItem) => Partial<ComponentProps<"h3">>);
};

const HomeFiveTeamSectionGenerated: FC<HomeFiveTeamSectionGeneratedProps> = ({
    sectionDiv0Div0Div0DivText = "OUR EXPERT TEAM",
    sectionDiv0Div0Div0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/title-icon1.svg",
    sectionDiv0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0H20H2Text = "Highly Qualified ENT Specialists",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0ImageWithBasePath1ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    teamSection346s,
    teamSection346sItemWrapper,
    teamSection346sRenderer,
    teamSection346sLinkVisible,
    teamSection346sLinkRenderer,
    teamSection346sImageVisible,
    teamSection346sImageRenderer,
    teamSection346sH3Visible,
    teamSection346sH3Renderer,
    teamSection346sLinkProps,
    teamSection346sImageProps,
    teamSection346sH3Props,
}) => {
    return (
        <section className="team-section-five section">
            <div className="container">
                <div className="section-header section-header-five text-center">
                    <div className="section-sub-title">
                        {" "}
                        {renderNode(sectionDiv0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0ImageWithBasePath0ImageRenderer, (
                            <SmartImage src={sectionDiv0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(sectionDiv0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                        ))}
                        {sectionDiv0Div0Div0DivText}
                    </div>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row justify-content-center g-4"}>
                    {renderCollectionNode(
                        teamSection346s,
                        (item: TeamSection346sItem) => (
                            <div className={item.className ?? "col-xl-3 col-lg-4 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "team-item-five"}>
                                    <div className={item.div0ClassName2 ?? "team-overley"}>
                                        {renderItemNode(teamSection346sImageVisible, teamSection346sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "team-img-1"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof teamSection346sImageProps === "function" ? teamSection346sImageProps(item) : (teamSection346sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        {renderItemNode(teamSection346sImageVisible, teamSection346sImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath1Src ?? "/Templates/Doccure/img/bg/team-bg-1.png"} alt={item.imageWithBasePath1Alt ?? "team-img-1"} className={item.imageWithBasePath1ClassName ?? "img-fluid img-2"} {...(typeof teamSection346sImageProps === "function" ? teamSection346sImageProps(item) : (teamSection346sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath1ImageProps === "function" ? divDiv0Div0ImageWithBasePath1ImageProps(item) : (divDiv0Div0ImageWithBasePath1ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "team-details"}>
                                        {renderItemNode(teamSection346sH3Visible, teamSection346sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title author-name"} {...(typeof teamSection346sH3Props === "function" ? teamSection346sH3Props(item) : (teamSection346sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(teamSection346sLinkVisible, teamSection346sLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} {...(typeof teamSection346sLinkProps === "function" ? teamSection346sLinkProps(item) : (teamSection346sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "author-dest"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            </div>
                        ),
                        teamSection346sItemWrapper,
                        teamSection346sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeFiveTeamSectionGenerated;
